module.exports = __webpack_public_path__ + "img/project.2234939f.svg";